import Flex from "../../../shared/components/Flex";
import React, { useMemo } from "react";
import { SensorDataDto } from "../api/sensorDataApi";
import Text from "../../../shared/components/Text";
import Button from "../../../shared/components/Button";
import Spacer from "../../../shared/components/Spacer";
import { useAppDispatch, useAppSelector } from "../../../shared/store/store";
import { setSelectedSensor } from "../slice/sensorDashboardSlice";
import Card from "../../../shared/components/Card";
import Padding from "../../../shared/components/Padding";
import Seperator from "../../../shared/components/Seperator";
import Pill from "../../../shared/components/Pill";
import { useNavigate } from "react-router-dom";
import statusToColor from "../utils/statusToColor";
import moment from "moment";
import ElectronicDisplayBoard from "./ElectronicDisplayBoard";
import { setShowDetail } from "../../sensor/slice";
import useDevice, { useSmallDevice } from "../../../shared/hooks/useDevice";
import useGetStatusMessage from "../hooks/useStatusFilter";

function SensorStatusBoardDetail(sensorData: SensorDataDto) {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const smallDevice = useSmallDevice();
    const device = useDevice();
    const isMobile = device === "mobile";
    // const sensorStatusNames = useAppSelector(state => state.sensorStatusName);
    
    // 디테일한 상태 정보 가져오기 (codeName: 살얼음경보 등, codeGroupName: 경보/주의/안전 등)

    const items = [
        // {
        //     label: "관리번호",
        //     value: <Text color={"rgba(85, 85, 85, 1)"}>{sensorData.sensorMngNo}</Text>
        // },
        // {
        //     label: "별칭",
        //     value: <Text color={"rgba(85, 85, 85, 1)"}>{sensorData.sensorAlias}</Text>
        // },
        {
            icon: <img alt="" src={"/images/ico_folder.png"} />,
            label: "IMEI",
            value: <Text color={"rgba(85, 85, 85, 1)"} noWrap={false}>{sensorData.imei}</Text>
        },
        {
            icon: <img alt="" src={"/images/ico_location2.png"} />,
            label: "주소",
            value: <Text style={{maxWidth: smallDevice ? "200px" : "80%"}} color={"rgba(85, 85, 85, 1)"} noWrap={false} textAlign="right">{sensorData.sensorAddress}</Text>
        },
        // {
        //     icon: <img alt="" src={"/images/ico_installdt.png"} />,
        //     label: "설치일자",
        //     value: <Text color={"rgba(85, 85, 85, 1)"}>{sensorData.sensorInstallAt}</Text>
        // },
        // {
        //     icon: <img alt="" src={"/images/ico_updatedt.png"} />,
        //     label: "제품 갱신 일시",
        //     value: <Text color={"rgba(85, 85, 85, 1)"}>{sensorData.lastDatetime}</Text>
        // }
    ]

    const handleBack = () => {
        dispatch(setSelectedSensor(null));
    };

    const handleProductStatus = () => {  
        navigate(`/sensor?IMEI=${sensorData.imei}`);
    };
    
    const {processingMap} = useGetStatusMessage();
    return (
        <Flex
            flexDirection="column"
            justifyContent="space-between"
            width={"100%"}
            height={"100%"}
            style={{ minHeight: 0 }}
        >
            <Flex
                fullWidth
                flexDirection="column"
                alignItems="start"
                gap={12}
            >

            <Card backgroundColor="#F5F7F9" border={0} shadow={0} paddingX={12} paddingY={16} fullWidth paddingBottom={sensorData.lastStatus === "점검" ? 16 : 16}>
                <Flex flexDirection="column" gap={28}>
                    <Flex flexDirection="column" gap={12}>
                        
                    <Flex alignItems="center" justifyContent="space-between">
                        <Text size={16} weight={"medium"}>설치일자</Text>
                        <Text variant="div" size={14} weight={"semibold"}>{moment(sensorData.sensorInstallAt).isValid() ? (isMobile ? moment(sensorData.sensorInstallAt).format("YYYY. MM. DD.") : moment(sensorData.sensorInstallAt).format("YYYY년 MM월 DD일")) : "-"}</Text>
                    </Flex>
                    <Card padding={12} border={0} shadow={0}>
                    <Flex flexDirection="column" gap={12}>
                        {
                            items.map((item, index) => (
                                <React.Fragment key={item.label}>
                                    <Flex alignItems="center" justifyContent="space-between">
                                        <Flex alignItems="center" gap={8}>
                                            {item.icon}
                                            <Text size={16} weight={"medium"}>{item.label}</Text>
                                        </Flex>
                                        {item.value}
                                    </Flex>
                                    {index !== items.length - 1 && <Seperator></Seperator>}
                                </React.Fragment>
                            ))
                        }

                    </Flex>
                    </Card>
                    </Flex>

                    <Flex alignItems="center" justifyContent="space-between">
                        <Text size={16} weight={"medium"}>제품 갱신 일시</Text>
                        <Text variant="div" size={14} weight={"semibold"}>{moment(sensorData.lastDatetime).isValid() ? (isMobile ? moment(sensorData.lastDatetime).format("YYYY. MM. DD. HH:mm:ss") : moment(sensorData.lastDatetime).format("YYYY년 MM월 DD일 HH시 mm분 ss초")) : "-"}</Text>
                    </Flex>
                    <Card padding={16} border={0} shadow={0}>
                        <Flex height="161px" justifyContent="space-around">
                            <Flex flexDirection="column" height="100%" alignItems="center" justifyContent="center">
                                <Text>온도</Text>
                                <div style={{height:"100px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                                    <img alt="" height={60} src={"/images/ico_big_thermometer.png"} />
                                </div>
                                <Text weight={"semibold"} size={18} color={"#0A1643"}>{sensorData.lastTmpr}℃</Text>
                            </Flex>
                            <Flex flexDirection="column" height="100%" alignItems="center" justifyContent="center">
                                <Text>습도</Text>
                                <div style={{height:"100px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                                    <img alt="" src={"/images/ico_big_humidity.png"} />
                                </div>
                                <Text weight={"semibold"} size={18} color={"#0A1643"}>{sensorData.lastHumidity}%</Text>
                            </Flex>
                            <Flex flexDirection="column" height="100%" alignItems="center" justifyContent="center">
                                <Text>풍속</Text>
                                <div style={{height:"100px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                                    <img alt="" src={"/images/ico_big_wind.png"} />
                                </div>
                                <Text weight={"semibold"} size={18} color={"#0A1643"}>{sensorData.lastWind}m/s</Text>
                            </Flex>
                        </Flex>
                            {/* <Spacer direction="vertical" size={8} />
                            <Pill
                                style={{borderRadius: 4}}
                                border={0}
                                height={43}
                                paddingY={4}
                                width={"100%"}
                                paddingX={16}
                                backgroundColor={statusToColor("점검").backgroundColor}
                                text={<Text size={"16px"} weight={"semibold"} color={statusToColor("점검").color}>{"점검"}</Text>}
                            /> */}
                    </Card>
                </Flex>
            </Card>
            <Card
                backgroundColor={statusToColor(sensorData.lastStatus === "점검" ? "점검" : processingMap.get(sensorData.lastStatus)).backgroundColor}
                border={0}
                shadow={0}
                fullWidth
            >
                <Flex
                    alignItems="center"
                    justifyContent="center"
                    height={60}
                >
                    <Text
                        color={statusToColor(sensorData.lastStatus === "점검" ? "점검" : processingMap.get(sensorData.lastStatus)).color}
                        weight={"bold"}
                        size={24}
                    >
                    {sensorData.lastStatus}
                    </Text>
                </Flex>
            </Card>
            </Flex>
            <Flex gap={16} style={{ flexShrink: 0, paddingTop: 16 }}>
                <Button variant="primary" fullWidth onClick={handleProductStatus}>
                    센서현황
                </Button>
                <Button variant="white" fullWidth onClick={handleBack}>
                    뒤로가기
                </Button>
            </Flex>
        </Flex>
    )
}

type DetailCardProps = {
    label: string;
    value: string;
    icon: React.ReactNode;
}
function DetailCard({ label, value, icon }: DetailCardProps) {
    return (
        <Card fullWidth backgroundColor="#F8FAFB" border={0} shadow={0} style={{flexBasis: "calc(50% - 6px)"}} height={"161px"}>
            <Flex flexDirection="column" justifyContent="center" alignItems="center" height={"100%"}>
                <div style={{height: "80px", width: "90px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    {icon}
                </div>
                <Text size={14} color={"#555555"}>{label}</Text>
                <Spacer direction="vertical" size={6} />
                <Text size={16} weight={"semibold"}>{value}</Text>
            </Flex>
        </Card>
    )

}
export default SensorStatusBoardDetail;